<template>
  <div class="white-container full-page-container activity-img-setting">
    <el-tabs v-model="activeTab" class="activity-img-tabs">
      <el-tab-pane label="新手体验" name="0" />
      <el-tab-pane label="进阶训练" name="1" />
      <el-tab-pane label="以赛会友" name="2" />
    </el-tabs>
    <div class="img-upload-list">
      <UploadImage
        :url="formData[activeTab].listImageUrl"
        title="列表页图片"
        size-tips="381*561"
        :limit-size="5"
        save-path="running/"
        @upload="data => (formData[activeTab].listImageUrl = data)"
      />
      <UploadImage
        :url="formData[activeTab].headImageUrl"
        title="活动详情页"
        size-tips="1125*1125"
        :limit-size="5"
        save-path="running/"
        @upload="data => (formData[activeTab].headImageUrl = data)"
      />
      <UploadImage
        :url="formData[activeTab].shareImageUrl"
        title="分享海报"
        size-tips="849*849"
        :limit-size="5"
        save-path="running/"
        @upload="data => (formData[activeTab].shareImageUrl = data)"
      />
      <UploadImage
        :url="formData[activeTab].shareCardImageUrl"
        title="分享卡片"
        size-tips="500*400"
        :limit-size="5"
        save-path="running/"
        @upload="data => (formData[activeTab].shareCardImageUrl = data)"
      />
    </div>
    <div class="save-btn-wrapper">
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import UploadImage from '@/components/UploadImage';
import { getImageConfig, saveImageConfig } from '@/api/rugby';

export default {
  name: 'ActivityImgSetting',
  components: { UploadImage },
  data() {
    return {
      activeTab: '0',
      formData: {
        0: { type: 0, listImageUrl: '', headImageUrl: '', shareImageUrl: '', shareCardImageUrl: '' },
        1: { type: 1, listImageUrl: '', headImageUrl: '', shareImageUrl: '', shareCardImageUrl: '' },
        2: { type: 2, listImageUrl: '', headImageUrl: '', shareImageUrl: '', shareCardImageUrl: '' },
      },
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    loadConfig() {
      getImageConfig().then(res => {
        console.log('getImageConfig**-**', res);
        if (res?.list && res?.list?.length) {
          res.list.forEach(item => {
            const type = String(item.type);
            if (this.formData[type]) {
              this.formData[type] = { ...this.formData[type], ...item };
            }
          });
        }
      });
    },
    save() {
      const item = this.formData[this.activeTab];
      const hasImage = item.listImageUrl || item.headImageUrl || item.shareImageUrl || item.shareCardImageUrl;
      if (!hasImage) {
        this.$message.warning('请至少上传一张图片');
        return;
      }
      const param = { list: [{ ...item }] };
      saveImageConfig(param).then(() => {
        this.$message.success('保存成功');
        this.loadConfig();
      }).catch(err => {
        this.$message.error(err.errorMessage || '保存失败');
      });
    },
  },
};
</script>

<style lang="less" scoped>
.activity-img-setting {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.img-upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;

  /deep/ .uploader .uploader-image .el-upload {
    width: 200px;
    height: 200px;
  }

  /deep/ .uploader .uploader-image .el-icon-plus {
    width: 200px;
    height: 200px;
    line-height: 200px;
  }
}

.save-btn-wrapper {
  margin-top: auto;
  padding: 20px 0;
  display: flex;
  justify-content: center;

  .el-button {
    width: 120px;
    height: 50px;
  }
}
</style>
